import React, { useRef, useState } from "react";
import { View, TextInput, StyleSheet, Pressable } from "react-native";
import colors from "@constants/color";
import Text from "@components/CustomText";
import SearchIcon from "@assets/svg/SearchIcon";
import CrossCircle from "@assets/svg/CrossCircle";
import BackButton from "@components/BackButton";
import { fonts } from "../../constants/metrics";

const HeaderWithSearch = ({
  headertitle,
  headerStyle,
  navigation,
  onPressCrossIcon = () => {},
  goingBackHandler,
  alwaysEnable = true,
  numberOfLines = 0,
  testID = "",
  isSearchEnabled = false,
  onSearchInputChange = () => {},
  searchPlaceholder = "",
  rightComponent = <View />,
  bottomComponent = <View />,
  subHeadingComponent = <View />,
}) => {
  const [searchText, setSearchText] = useState("");
  const textInputRef = useRef(null);

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <View>
          <BackButton
            onPress={goingBackHandler ?? navigation.goBack}
            alwaysEnable={alwaysEnable}
          />
        </View>
        <View style={styles.headerTitle}>
          <Text
            variant="title_18"
            numberOfLines={numberOfLines}
            style={[styles.titleText, headerStyle || null]}
          >
            {headertitle}
          </Text>
          {subHeadingComponent}
        </View>
        <View style={styles.rightComponentContainer}>
          <View style={styles.rightComponent}>{rightComponent}</View>
        </View>
      </View>
      {isSearchEnabled && (
        <SearchField
          searchPlaceholder={searchPlaceholder}
          onSearchInputChange={onSearchInputChange}
          searchText={searchText}
          onPressCrossIcon={onPressCrossIcon}
          textInputRef={textInputRef}
          testID={testID}
          setSearchText={setSearchText}
        />
      )}
      <View style={styles.bottomComponent}>{bottomComponent}</View>
    </View>
  );
};

const SearchField = ({
  searchPlaceholder,
  onSearchInputChange,
  searchText,
  onPressCrossIcon,
  textInputRef,
  testID = "",
  setSearchText = () => {},
}) => {
  return (
    <View style={[styles.headerContainer, { elevation: 0 }]}>
      <View style={styles.searchContainer}>
        <View style={styles.searchInputContainer}>
          <SearchIcon height={20} width={20} />
          <TextInput
            ref={textInputRef}
            testID={testID}
            placeholder={searchPlaceholder}
            autoFocus={true}
            placeholderTextColor={colors.lightBlack}
            cursorColor={colors.lightBlack}
            returnKeyType="done"
            style={styles.searchInput}
            onChangeText={(text) => {
              setSearchText(text);
              onSearchInputChange(text);
            }}
          />
        </View>

        {searchText.length > 0 ? (
          <Pressable
            onPress={() => {
              textInputRef.current.clear();
              onPressCrossIcon();
              setSearchText("");
            }}
            testID="searchIcon"
            style={styles.crossIconContainer}
          >
            <CrossCircle bgColor="rgba(0,0,0,0.7)" height={20} width={20} />
          </Pressable>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  headerContainer: {
    paddingTop: 7,
    backgroundColor: colors.white,
    shadowColor: "rgba(0, 0, 0, 1)",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowRadius: 5,
    shadowOpacity: 0.8,
    elevation: 3,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },

  headerTitle: {
    marginLeft: 4,
    flex: 1,
  },
  titleText: {
    fontSize: fonts.content1,
  },
  rightComponentContainer: {
    alignContent: "center",
    justifyContent: "flex-start",
    marginRight: 16,
  },
  rightComponent: {
    right: 0,
    marginVertical: 8,
  },
  searchContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 15,
    marginBottom: 12,
    paddingLeft: 12,
    borderRadius: 6,
    borderColor: colors.black,
    borderWidth: 0.5,
    justifyContent: "space-between",
    paddingRight: 12,
    height: 50,
  },
  searchInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  searchInput: {
    width: "85%",
    backgroundColor: colors.white,
    color: colors.black,
    fontSize: 14,
    fontWeight: "500",
  },
  crossIconContainer: {
    padding: 5,
  },
  bottomComponent: {
    backgroundColor: colors.white,
  },
});

export default HeaderWithSearch;
